import { useEffect as e } from "react";
//#region src/index.ts
var t = (e) => {
	parent.window && parent.window.postMessage(e, "*");
}, n = (t, n) => {
	e(() => {
		let e;
		if (typeof t == "object" && "location" in t) e = parent;
		else if (t instanceof Object && "current" in t) e = t.current?.contentWindow;
		else return;
		if (e === null) return;
		let r = (t) => {
			if (e !== t.source || t.data?.type === void 0 || t.data?.type === "") return;
			let { type: r } = t.data;
			(typeof r == "string" || Object.prototype.toString.call(r) === "[object String]") && n(t.data);
		};
		return window.addEventListener("message", r), () => {
			window.removeEventListener("message", r);
		};
	}, [t, n]);
};
//#endregion
export { t as sendEvent, n as useSubscriber };
